{
  "WALLBOARD": {
    "LOADING": "Hleð símaröðum...",
    "NO_QUEUES": "Engar símaraðir fundust.",
    "NO_AGENTS": "Engir þjónustufulltrúar á netinu í þessari röð.",
    "UNKNOWN_CALLER": "Óþekktur hringjandi",
    "STATUS": "Staða",
    "TIME": "Tími",
    "AGENT": "Þjónustufulltrúi",
    "EXTENSION": "Aukalína",
    "READY": "Tilbúnir þjónustufulltrúar",
    "ON_CALL": "Þjónustufulltrúar í símtali",
    "PAUSED": "Þjónustufulltrúar í hléi",
    "WAITING": "Símtöl í bið",
    "MISSED_CALLS": "Ósvöruð símtöl",
    "HANDLED_CALLS": "Afgreidd innhringd símtöl",
    "OUTBOUND_CALLS": "Afgreidd úthringd símtöl",
    "AVAILABILITY": "Framboð",
    "AVAILABILITY_TOOLTIP": "Hlutfall innhringdra símtala sem þjónustufulltrúar svöruðu (símtöl sem var svarað)",
    "AGENTS_COUNT": "({onCall} í símtali / {total} samtals)",
    "NO_AVAILABLE": "(enginn á netinu)",
    "WAITING_CALLERS_COUNT": "{count} í bið",
    "CALLER": "Hringjandi",
    "NUMBER": "Númer",
    "WAIT_TIME": "Biðtími",
    "ACTION": "Aðgerð",
    "PICKUP_CALL": "Svara",
    "PICKUP_SUCCESS": "Beiðni um að svara símtali send.",
    "PICKUP_ERROR": "Ekki tókst að svara símtalinu. Vinsamlegast reyndu aftur.",
    "PICKUP_DISABLED_TOOLTIP": "Þú getur ekki svarað símtali á meðan þú ert í símtali eða ekki á netinu.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Enginn aðgangur"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Enginn aðgangur"
    }
  }
}
